import { StyledDataArrayTableComponent } from 'acr_ui/sources/components/tables/styledDataArrayTable';

// Widgets used in place of the standard ones for reports published before 2021.
export const RETRO_COMPAT_2020_WIDGETS: Record<string, any> = {
  progress_towards_gender_equality_indicators: StyledDataArrayTableComponent,
  protection_indicators: StyledDataArrayTableComponent,
  accountability_to_affected_population_indicators:
    StyledDataArrayTableComponent,
  environment_indicators: StyledDataArrayTableComponent,
};

// Data source ids rendered in the section header instead of the module list.
export const SPECIAL_LOCATION_OF_WIDGETS: Record<string, string[]> = {
  header: ['strategic_outcome_title'],
};

export const MODE_TITLE_MAP: Record<string, string> = {
  edit: 'Edit',
  post: 'Post version',
  save: 'Save as draft',
  cancel: 'Close',
};

export const disabledBenDataNote2020 =
  'For the 2020 reporting period, disability data has been collected using a variety of approaches, according to the ' +
  'existing needs, capacity, and experience of various WFP activities and operational contexts. Moving forward, as' +
  ' part of the 2020 Disability Inclusion Road Map, WFP will be building on this experience to mainstream and ' +
  'standardise disability data collection methodologies, aligning with international standards and best practices. \n';

export const disabledBenDataNote2021 =
  'For the 2021 reporting period, disability data has been collected using a variety of approaches; the WHO 15 ' +
  'percent global disability prevalence average, head counts in single activities, or disaggregation of data' +
  ' from post distribution monitoring reports (PDMs). As standardised guidance was not available in WFP prior' +
  ' to 2020, these methods have varied according to the existing needs, capacity, and experience of various ' +
  'WFP activities and operational contexts. Moving forward, as part of the 2020 disability inclusion road map, ' +
  'WFP is building on continued efforts to mainstream and standardise disability data collection methodologies, ' +
  'aligning with international standards and best practices. \n';

export const disabledBenDataNote2022 =
  'For the 2022 reporting period, disability data has been collected using a variety of approaches; head counts' +
  ' in single activities, disaggregation of data from post distribution monitoring reports (PDMs) and other' +
  ' data sources from UN agencies and National Census data. As standardized guidance was not available in WFP ' +
  'prior to 2020, these methods have varied according to the existing needs, capacity, and experience of various ' +
  'WFP activities and operational contexts. Moving forward, as part of the 2020 Disability Inclusion Road Map, ' +
  'WFP is building on continued efforts to mainstream and standardize disability data collection methodologies, ' +
  'aligning with international standards and best practices. \n';

export const DATA_KEY_ON_DATA_SET: Record<string, string | string[]> = {
  total_beneficiaries: 'total_actual_beneficiaries',
  beneficiaries_by_residence_status: 'total_adjusted_beneficiaries_res_status',
  beneficiaries_by_age_group: 'total_adjusted_beneficiaries_age_group',
  beneficiaries_by_sex_and_age_group: 'total_adjusted_beneficiaries_age_group',
  beneficiaries_by_programme_area: 'actual_and_planned_adjustments',
  beneficiaries_by_modality: ['beneficiaries_by_modality'],
  total_food_and_cbt: [
    'food_and_report_block_food_mt',
    'annual-cbt-distribution',
  ],
  total_transfers_by_modality: [
    'food_and_report_block_food_mt',
    'annual-cbt-distribution',
  ],

  annual_food_transfer: 'food_and_report_block_food_mt',
  annual_cash_based_transfer_and_commodity_voucher: 'annual-cbt-distribution',
  annual_food_distribution: 'food_and_report_block_food_mt',
  annual_cbt_and_commodity_voucher_distribution: 'annual-cbt-distribution',
  wfp_contribution_to_sdgs: 'acr-sdg',

  strategic_outcome_title: 'strategic_outcome_strategic_outcomes',
  strategic_outcome_and_output_results: 'outputs_outcomes',
  output_and_outcome_results: 'outputs_outcomes',
  annual_csp_financial_overview_by_strategic_outcome_and_activity:
    'ca_fm_activity',
  annual_financial_overview_by_strategic_outcome_and_activity: 'ca_fm_activity',
  wfp_gender_and_age_marker: 'gam',

  progress_towards_gender_equality_indicators: 'acr-cross-cutting_progress',
  protection_indicators: 'acr-cross-cutting_protection',
  accountability_to_affected_population_indicators:
    'acr-cross-cutting_population',
  accountability_to_affected_people_indicators: 'acr-cross-cutting_population',
  environment_indicators: 'acr-cross-cutting_environment',
  environmental_sustainability_indicators: 'acr-cross-cutting_environment',
  nutrition_integration_indicators: 'acr-cross-cutting_nutrition',

  // 2026 ACR Template — Cross-Cutting Priorities (7 sub-sections, indicators CC.1–CC.8)
  ensuring_protection_indicators: 'acr-cross-cutting_protection', // CC.1
  ensuring_accountability_to_affected_people_indicators:
    'acr-cross-cutting_population', // CC.2
  'empowering_women_and_girls,_and_advancing_equality_indicators':
    'acr-cross-cutting_progress', // CC.3
  integrating_environmental_sustainability_indicators:
    'acr-cross-cutting_environment', // CC.4
  enabling_nutrition_and_healthy_diets_indicators:
    'acr-cross-cutting_nutrition', // CC.5
  'embedding_humanitarian_principles_and_conflict-sensitivity_indicators':
    'acr-cross-cutting_humanitarian', // CC.6
  promoting_localization_indicators: 'acr-cross-cutting_localization', // CC.7
  mainstreaming_assurance_indicators: 'acr-cross-cutting_assurance', // CC.8
};
